<div class="d-flex flex-column h-100" id="devicePriceContent">
  <div class="right_section_header" id="devicePriceHeader">
    <img class="header_icon" alt="price content" />
    <span i18n="@@device-price-content.title.price-content">PRICE CONTENT</span>
  </div>
  <div class="right_section_body price_content_tab">
    <div *ngIf='selectedLength && priceMetaData?.enablePriceMultiDevices && !priceMetaData?.blockSKU' class='text-danger d-flex flex-row p-2 text-justify warningText'>
      <em class="error_icon"></em>
      <span>{{globalConst.PRICE_WARNING_TOOLTIP_TEXT}}</span>
    </div>
    <div class="form_with_preview" *ngIf='!selectedLength || priceMetaData?.enablePriceMultiDevices'>
      <form>
        <ng-template #priceTipContent>
          <div *ngIf="priceMetaData?.blockSKU && selectedLength && priceMetaData?.enablePriceMultiDevices">
            <span>{{globalConst.PRICE_TOOLTIP_TEXT1}}</span><br/>
            <span>{{globalConst.PRICE_TOOLTIP_TEXT2}}</span>
          </div>
        </ng-template>
        <div class="mb-3 font-weight-bold" >
          <span i18n="@@device-price-content.title.device-price" >Device Price                 
            <a class="info_icon" tabindex="0" *ngIf="priceMetaData?.blockSKU && selectedLength && priceMetaData?.enablePriceMultiDevices">
            <img alt="Info" placement="right" [ngbTooltip]="priceTipContent"  [autoClose]="false"  #ClipBoard = "ngbTooltip" tooltipClass="my-price-tooltip" triggers="manual" (mouseenter)="toolTipOpen()" (mouseleave)="toolTipOpen()" class="info_circle_icon" /></a>
          </span>
        </div>
        <div class="price_row" [ngClass]="{'blockSKU': priceMetaData?.blockSKU && selectedLength && priceMetaData?.enablePriceMultiDevices}">
          <div class="form-group">
            <label for=""><span i18n="@@device-price-content.title.primary-price">Primary Price</span>
              <!-- Commenting as part of UAT-384 -->
              <!-- <strong class="text-danger"> *</strong> -->
            </label>
            <input type="text" name="primaryPriceValue" class="form-control" id="primaryprice"
              placeholder="{{placeholderPrimaryPrice}}" [(ngModel)]='primaryPriceValue'
              (input)="getPriceInput($event)" />
          </div>
          <div class="form-group" id="priceContentTitle">
            <label for=""><span i18n="@@device-price-content.title.color">Color</span></label>
            <div id="priceCorlr">
              <input [(colorPicker)]="primaryColor" [ngStyle]="{'background-color':primaryColor}"
                (colorPickerChange)="updateBgColor($event,'primary')" class="color_picker_button default" name="bgcolor"
                readonly />
            </div>
          </div>
        </div>

        <div class="price_row" id="priceRow" [ngClass]="{'blockSKU': priceMetaData?.blockSKU && selectedLength && priceMetaData?.enablePriceMultiDevices}">
          <div class="form-group">
            <label for=""><span i18n="@@device-price-content.title.secondray-price">Secondary (Sale)
                Price</span></label>
            <input type="text"
              [disabled]='primaryPriceValue ? (primaryPriceValue.trim()?.length === 0  ? true : false) : true'
              name="secondaryPriceValue" class="form-control" id="" placeholder="{{placeholderSecondaryPrice}}"
              [(ngModel)]='secondaryPriceValue' (input)="getSecondaryPriceInput($event)" />
          </div>
          <div class="form-group" id="priceContentTtlColor">
            <label for="bannercarouselcolor"><span i18n="@@device-price-content.title.color">Color</span></label>
            <div id="bgColorBtn">
              <input [(colorPicker)]="secondaryColor" [ngStyle]="{'background-color':secondaryColor}"
                (colorPickerChange)="updateBgColor($event,'secondary')" class="color_picker_button default"
                name="bgcolor" readonly />
            </div>
          </div>
        </div>
        <!-- Price strikethrough -->
        <div class="price_row" *ngIf='!selectedLength || priceMetaData?.enablePriceMultiDevices' [ngClass]="{'blockSKU': priceMetaData?.blockSKU && selectedLength && priceMetaData?.enablePriceMultiDevices}">
          <div class="form-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="priPriceStrike"
              [disabled]='(primaryPriceValue ? (primaryPriceValue.trim()?.length === 0  ? true : false) : true) || (secondaryPriceValue ? (secondaryPriceValue.trim()?.length === 0  ? true : false) : true)'
                [checked]='priceStrikethrough'
                (change)='togglePriceStrikethrough()' />
              <label class="form-check-label UnisonCheckbox" for="priPriceStrike">
                <span i18n="@@device-price-content.title.primary-strikethrough">Primary Strikethrough
                  (<del>$2099.00</del>)</span>
              </label>
            </div>
          </div>
          <div class="form-group">
            <label for=""><span i18n="@@device-price-content.title.price-background-color">Price Background
                color</span></label>
            <div>
              <input [(colorPicker)]="backgroundColor" [ngStyle]="{'background-color':backgroundColor}"
                (colorPickerChange)="updateBgColor($event,'backgroundColor')" class="color_picker_button default"
                name="bgcolor" readonly />
            </div>
          </div>
        </div>
      </form>
      <figure class="figure">
        <img class="img-fluid custom-price" alt="custom price eg." />
        <figcaption class="figure-caption">
          <span i18n="@@device-price-content.title.custom-device-price"><strong>Example:</strong> Customize the price of this device.</span>
        </figcaption>
      </figure>
    </div>
    <div [ngClass]="{'display-fig':selectedLength}">
      <div>
        <div class="mb-3 font-weight-bold">
          <span i18n="@@device-price-content.title.price-clickability">Price Clickability</span>
          <!-- Commenting as part of UAT-384 -->
          <!-- <strong class="text-danger"> *</strong> -->
        </div>
        <!-- radio button Price clickable  -->
        <form class="form-inline mb-3">
          <div class="form-check" id="priceClickable">
            <input *ngIf='!selectedLength' class="form-check-input" type="radio" name="priceClickability" id="None"
              [checked]='noneSelected' (change)='priceClickAbility("none")' />
            <label *ngIf='!selectedLength' class="form-check-label" for="None"><span
                i18n="@@device-price-content.title.none-label">None</span></label>
          </div>
          <div class="form-check" id="largePriceCalloutDiv">
            <input class="form-check-input" type="radio" name="priceClickability" id="LargePriceCallout"
              [checked]='largePriceSelected' (change)='priceClickAbility("largePrice")' />
            <label class="form-check-label" for="LargePriceCallout"><span
                i18n="@@device-price-content.title.large-price-callout">Large Price Callout</span></label>
          </div>
          <div class="form-check" [ngbPopover]="(isPriceEmpty || isPriceEmpty === undefined)? priceContentEmptyDesc:''"
            placement="right" triggers="mouseenter:mouseleave" id="priceClickFrmCheck">
            <input class="form-check-input" type="radio" name="priceClickability" id="PriceContentGroup"
              [checked]='priceContentSelected' (change)='priceClickAbility("priceContent")'
              [disabled]='(isPriceEmpty || isPriceEmpty === undefined)' />
            <label class="form-check-label" for="PriceContentGroup"
              [ngClass]="!(isPriceEmpty || isPriceEmpty === undefined) ? '': 'price-label-disabled'">
              <span i18n="@@device-price-content.title.price-content-grp-label">Price Content Group</span>
            </label>
          </div>
        </form>

        <!-- Large price callout -->
        <div [ngClass]="{'displayControl':!largePriceSelected, 'large_price_row':largePriceSelected}" id="priceDescTxt">
          <div class="form-group" id="priceDescTxtFrmGrp">
            <label for="PriceDescText">
              <span i18n="@@device-price-content.title.price-desc-text">Price Description Text</span>
            </label>
            <textarea (input)="getPriceInput($event)" maxLength="100" [(ngModel)]="priceDescriptionText"
              class="form-control" id="PriceDescText" rows="4"></textarea>
            <label class="mt-2"><span i18n="@@device-price-content.title.char-max-limit">Max 100
                characters</span></label>
          </div>
          <div class="form-group" id="contentTitleColor">
            <label for=""><span i18n="@@device-price-content.title.color">Color</span></label>
            <div>
              <input [(colorPicker)]="priceDescriptionColor" [ngClass]="{'mr-2':selectedLength}"
                [ngStyle]="{'background-color':priceDescriptionColor}"
                (colorPickerChange)="updateBgColor($event,'priceDescription')" class="color_picker_button default"
                name="bgcolor" readonly />
            </div>
          </div>
        </div>
        <!-- price content  -->
        <div [ngClass]="{'displayControl':!priceContentSelected}" id="priceContentGrp">
          <div id="priceLengthDiv"><strong><span i18n="@@device-price-content.title.price-content-grp">{{priceLength}}
                Price Content
                Groups</span></strong></div>
          <div id="addPriceContentGrp">
            <span i18n="@@device-price-content.title.add-price-content-grp">Add a Price Content Group of up to 3 pages
              to
              your device price in the IPOS footer.</span>
          </div>
          <div id="iposcenPriceContent">
            <iposcen-price-content [idFromPriceContent]='idselected' (sendLengthPriceContent)="getPriceLength($event)"
              (sendPriceContentData)='setPriceContentData($event)' [isdevicePrice]='isPriceContent'>
            </iposcen-price-content>
          </div>
        </div>
      </div>
      <div id="customizeThisDevice" *ngIf='selectedLength && !priceMetaData?.enablePriceMultiDevices'>

        <img class="img-fluid custom-price" alt="custom price eg." />
        <figcaption class="figure-caption">
          <span i18n="@@device-price-content.title.custom-device-price"><strong>Example:</strong> Customize the price of this device.</span>
        </figcaption>

      </div>
    </div>
  </div>

  <!-- CTA Buttons -->
  <div class="button_wrapper justify-content-end" id="btnWrapper">
    <button type="button" class="btn btn-outline-primary btn-lg" data-dismiss="modal" [disabled]='!enableSavechanges'
      (click)='cancel()'>
      {{cancelBtn}}
    </button>
    <!-- Commenting this line as part of UAT-377-->
    <!-- <button type="button" [disabled]='priceLength === 0 || !(selectedLength || primaryPriceValue?.trim() !== "")' class="btn btn-primary btn-lg gtmEditDeviceSavePromoContent"
      (click)="sendDataToStore()">
      <span i18n="@@device-price-content.title.save-changes">Save Changes</span>
    </button> -->
    <button type="button" [disabled]='!enableSavechanges' class="btn btn-primary btn-lg gtmEditDeviceSavePromoContent"
      (click)="sendDataToStore()">
      <span i18n="@@device-price-content.title.save-changes">Save Changes</span>
    </button>
  </div>
</div>
<!--popup-message -->
<div class="container" id="containerPopup">
  <div class="modal-dialog-centered" *ngIf="openModalPopup" id="modalDialogMsg">
    <div class="modal-backdrop show" id="modalBackdropMsg"></div>
    <div class="modal" id="myModal">
      <div class="modal-dialog" id="myModalDialog">
        <div class="modal-content" id="modalContent">
          <div _ngcontent-fjy-c198="" class="close" (click)="closeModal()" id="closeModal"><img _ngcontent-fjy-c198=""
              alt="close" class="modal-close-icon"></div>
          <div class="modal-body" id="modalBody">
            <div *ngIf='!isCancel' class="action_on_pending_user" id="actionOnPendingUsr">
              <span class="success_img"></span>
            </div>
            <div class="action-success-msg left_align_title" id="successMsg">
              <span>{{successMessage}}</span>
            </div>
            <div class="card_desc left_align" id="desc">
              <span>{{description}}</span>
            </div>
          </div>
          <div *ngIf='isCancel' class='modal-footer' id="modalFooter">
            <button class='btn btn-outline-primary btn-lg' (click)="closeModal()">{{buttonLabelNo}}</button>
            <button class='btn btn-primary btn-lg' (click)='dismiss()'>{{buttonLabelCancel}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>